import { render, staticRenderFns } from "./MailSignPage.vue?vue&type=template&id=27f9543e&"
import script from "./MailSignPage.vue?vue&type=script&lang=ts&"
export * from "./MailSignPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports